// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__nuAyP","itemsWrapper":"Navbar_itemsWrapper__8JgHf","fillMax":"Navbar_fillMax__M9eXW"};